import React from 'react';
import { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import '../assets/styles/crew-assignment-status.css';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { docsActions } from '_actions';

const TORWidget = ({ toggle, widgetid, visibility }) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(-1);

  const fetchPendingDocuments = async (docTypes) => {
    let reqData = {
      doc_types: docTypes,
      doc_category: 3,
    };
    const res = await dispatch(docsActions.getAllDocs(reqData));
    if (res.success) {
      setCount(res?.data?.total);
    }
  };

  const getDocTypes = async () => {
    const res = await dispatch(docsActions.getDocTypes());
    if (res.length > 0) {
      const timeOffRequestDocType = res.find(
        (res) => res.slug === 'time-off-request'
      );
      if (timeOffRequestDocType) {
        const timeOffRequestId = timeOffRequestDocType.id;
        fetchPendingDocuments(timeOffRequestId);
      }
    }
  };

  useEffect(() => {
    getDocTypes();
  }, []);

  return (
    <div className="dashboard_expiration_date_outer">
      <div className="dashboard_expiration_date inner_head">
        <h2>
          Time Off Requests<span className="drag-icon-controller"></span>
        </h2>
        <span
          className="toggle-controller"
          aria-owns="tor-stats"
          onClick={(event) => {
            toggle(event, widgetid);
          }}
        ></span>
      </div>
      <div
        className="employee_stats_details assignment_stats-details"
        aria-expanded={visibility === 1 ? 'true' : 'false'}
        id="tor-stats"
      >
        <div>
          <h4>TOR Documents:</h4>
          {count !== -1 ? (
            <div>
              {count !== 0 ? <h3>{count}</h3> : <h3>No Documents found</h3>}
            </div>
          ) : (
            <div className="dashboard_expiration_date_no_data">
              <img
                className="loader"
                alt="Loader"
                src={require('../assets/images/loader.gif').default}
              />
            </div>
          )}
        </div>
        {count !== 0 && (
          <>
            <span className="view_tor_button">
              <Link to="/tor-pending-docs">View TOR Documents</Link>
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default withRouter(TORWidget);
